function About() {
  return (
    <>
      <header>
        <div id="carouselExampleCaptions" className="carousel slide hm-slider">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img src="/img/about-banner.jpg" className="d-block w-100" alt="..." />
            </div>
          </div>
        </div>
      </header>
      <section className="page-title mt-2">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="about-head text-left">
                <h1>ABOUT US</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="about pt-5 pb-5">
        <div className="full-width-container pt-5">
          <div className="row align-items-center">
            <div className="col-md-6 ps-md-0">
              <div className="project-heading">
                <img
                  src="/img/motto.jpg"
                  style={{ borderRadius: "5px" }}
                  className="img-fluid"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="project1-heading">
                <h4>OUR MOTTO</h4>
                <p>
                  At Shree Mahavir Group, we believe every venture begins with a
                  vision. Whether it's forging new connections, transforming ideas
                  into skyscrapers, or unveiling innovative designs to the world,
                  we understand the immense power of your narrative. For over 30
                  years, we have been an established industry leader, dedicated to
                  turning dreams into reality.
                </p>
                <p>
                  Our dynamic team comprises seasoned professionals with 20 to 25
                  years of expertise, ensuring excellence in every project we
                  undertake. Supported by a robust workforce of nearly 300 skilled
                  workers and state-of-the-art machinery, we have the capability
                  to tackle even the most challenging projects with confidence.
                </p>
                <p>
                  Over the years, we have successfully delivered more than 10
                  residential and commercial redevelopment complexes, showcasing
                  our ability to meet diverse needs and exceed expectations. Our
                  proven expertise in redevelopment projects is evident in our
                  track record, with 10 completed projects and 8 ongoing.
                </p>
                <p>
                  At Shree Mahavir Group, we are committed to providing the
                  highest level of quality and satisfaction to both buyers and
                  original owners. Our dedication to excellence ensures that every
                  project we undertake not only meets but surpasses the
                  aspirations of those we serve. Join us on a journey where vision
                  meets reality, and together, we will build a future that stands
                  tall.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="who-we-are pt-5 pb-5" style={{ background: "#f8f9fa" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="title text-center mb-5">
                <h1>WHO WE ARE</h1>
              </div>
              <div className="who-we-are-content text-center">
                <h2 style={{ color: "#695041", marginBottom: "20px" }}>
                  About Shree Mahavir Group
                </h2>
                <h4 style={{ color: "#333", marginBottom: "30px", fontWeight: 300 }}>
                  A Real Estate Developer<br />The House of Trust & Reliability
                </h4>
                <div className="row justify-content-center">
                  <div className="col-lg-4 col-md-6 mb-4">
                    <div
                      className="card h-100"
                      style={{
                        background: "#f8f9fa",
                        border: "none",
                        boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <div
                        className="card-body p-4"
                        style={{ fontSize: "18px", lineHeight: 1.8, color: "#555" }}
                      >
                        With over 25+ years of excellence, Shree Mahavir Group has
                        established itself as a trusted name in Mumbai&rsquo;s
                        real estate landscape. With 15+ successfully delivered
                        projects and 10+ upcoming developments, the group
                        continues to shape spaces that reflect quality,
                        commitment, and long-term value.
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 mb-4">
                    <div
                      className="card h-100"
                      style={{
                        background: "#f8f9fa",
                        border: "none",
                        boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <div
                        className="card-body p-4"
                        style={{ fontSize: "18px", lineHeight: 1.8, color: "#555" }}
                      >
                        Founded with a vision to create homes built on trust and
                        transparency, the group has consistently focused on
                        delivering well-planned developments that cater to
                        evolving lifestyles. Over the years, Shree Mahavir Group
                        has grown from strength to strength, combining experience
                        with modern design, efficient planning, and customer-first
                        thinking.
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 mb-4">
                    <div
                      className="card h-100"
                      style={{
                        background: "#f8f9fa",
                        border: "none",
                        boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <div
                        className="card-body p-4"
                        style={{ fontSize: "18px", lineHeight: 1.8, color: "#555" }}
                      >
                        Driven by a commitment to reliability, the group
                        emphasizes clear processes, timely delivery, and
                        thoughtful execution across every project. With a strong
                        foundation and a forward-looking approach, Shree Mahavir
                        Group continues to create developments that offer both
                        comfort and lasting value.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="core-values pt-5 pb-5" style={{ background: "#f8f9fa" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="title text-center mb-5">
                <h1>OUR CORE VALUES</h1>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div
                className="value-card h-100 text-center p-4"
                style={{
                  background: "#fff",
                  borderRadius: "10px",
                  boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
                }}
              >
                <i
                  className="fa fa-handshake-o"
                  style={{ fontSize: "50px", color: "#695041", marginBottom: "20px" }}
                ></i>
                <h3 style={{ color: "#695041", marginBottom: "15px" }}>Trust</h3>
                <p style={{ color: "#555", fontSize: "16px" }}>
                  Building lasting relationships through honesty and reliability
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div
                className="value-card h-100 text-center p-4"
                style={{
                  background: "#fff",
                  borderRadius: "10px",
                  boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
                }}
              >
                <i
                  className="fa fa-eye"
                  style={{ fontSize: "50px", color: "#695041", marginBottom: "20px" }}
                ></i>
                <h3 style={{ color: "#695041", marginBottom: "15px" }}>Transparency</h3>
                <p style={{ color: "#555", fontSize: "16px" }}>
                  Ensuring clarity in every transaction and interaction
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div
                className="value-card h-100 text-center p-4"
                style={{
                  background: "#fff",
                  borderRadius: "10px",
                  boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
                }}
              >
                <i
                  className="fa fa-clock-o"
                  style={{ fontSize: "50px", color: "#695041", marginBottom: "20px" }}
                ></i>
                <h3 style={{ color: "#695041", marginBottom: "15px" }}>Commitment</h3>
                <p style={{ color: "#555", fontSize: "16px" }}>
                  Delivering quality and consistency in every project
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div
                className="value-card h-100 text-center p-4"
                style={{
                  background: "#fff",
                  borderRadius: "10px",
                  boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
                }}
              >
                <i
                  className="fa fa-users"
                  style={{ fontSize: "50px", color: "#695041", marginBottom: "20px" }}
                ></i>
                <h3 style={{ color: "#695041", marginBottom: "15px" }}>
                  Customer-Centric Approach
                </h3>
                <p style={{ color: "#555", fontSize: "16px" }}>
                  Designing spaces that truly meet customer needs
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="mission-vision pt-5 pb-5" style={{ background: "#f9f9f9" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="title text-center mb-5">
                <h1>OUR MISSION & VISION</h1>
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <div
                className="mission-box"
                style={{
                  background: "#fff",
                  padding: "30px",
                  borderRadius: "10px",
                  boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
                  height: "100%",
                }}
              >
                <div className="mission-icon text-center mb-3">
                  <i
                    className="fa fa-bullseye"
                    style={{ fontSize: "50px", color: "#695041" }}
                  ></i>
                </div>
                <h3
                  className="text-center"
                  style={{ color: "#695041", marginBottom: "20px" }}
                >
                  OUR MISSION
                </h3>
                <p
                  style={{
                    fontSize: "18px",
                    lineHeight: 1.6,
                    color: "#333",
                    textAlign: "center",
                    marginBottom: 0,
                  }}
                >
                  To create thoughtfully designed spaces that offer quality
                  living, seamless experiences, and long-term value for every
                  customer.
                </p>
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <div
                className="vision-box"
                style={{
                  background: "#fff",
                  padding: "30px",
                  borderRadius: "10px",
                  boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
                  height: "100%",
                }}
              >
                <div className="vision-icon text-center mb-3">
                  <i
                    className="fa fa-eye"
                    style={{ fontSize: "50px", color: "#695041" }}
                  ></i>
                </div>
                <h3
                  className="text-center"
                  style={{ color: "#695041", marginBottom: "20px" }}
                >
                  OUR VISION
                </h3>
                <p
                  style={{
                    fontSize: "18px",
                    lineHeight: 1.6,
                    color: "#333",
                    textAlign: "center",
                    marginBottom: 0,
                  }}
                >
                  To be a trusted leader in real estate, known for delivering
                  quality developments and setting new benchmarks in modern
                  living.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="certifications pt-5 pb-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="title text-center mb-5">
                <h1>CERTIFICATIONS & AFFILIATIONS</h1>
              </div>
            </div>
            <div className="col-md-12">
              <div
                className="cert-grid"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  gap: "30px",
                }}
              >
                <div
                  className="cert-item text-center"
                  style={{
                    background: "#fff",
                    padding: "25px 35px",
                    borderRadius: "10px",
                    boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
                    minWidth: "200px",
                  }}
                >
                  <i
                    className="fa fa-certificate"
                    style={{ fontSize: "40px", color: "#695041", marginBottom: "15px" }}
                  ></i>
                  <h5 style={{ color: "#333" }}>CREDAI Member</h5>
                  <p style={{ fontSize: "12px", color: "#666", margin: 0 }}>
                    Confederation of Real Estate Developers' Association of India
                  </p>
                </div>
                <div
                  className="cert-item text-center"
                  style={{
                    background: "#fff",
                    padding: "25px 35px",
                    borderRadius: "10px",
                    boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
                    minWidth: "200px",
                  }}
                >
                  <i
                    className="fa fa-building"
                    style={{ fontSize: "40px", color: "#695041", marginBottom: "15px" }}
                  ></i>
                  <h5 style={{ color: "#333" }}>MCHI Member</h5>
                  <p style={{ fontSize: "12px", color: "#666", margin: 0 }}>
                    Maharashtra Chamber of Housing Industry
                  </p>
                </div>
                <div
                  className="cert-item text-center"
                  style={{
                    background: "#fff",
                    padding: "25px 35px",
                    borderRadius: "10px",
                    boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
                    minWidth: "200px",
                  }}
                >
                  <i
                    className="fa fa-check-square"
                    style={{ fontSize: "40px", color: "#695041", marginBottom: "15px" }}
                  ></i>
                  <h5 style={{ color: "#333" }}>RERA Registered</h5>
                  <p style={{ fontSize: "12px", color: "#666", margin: 0 }}>
                    All Projects Registered Under RERA
                  </p>
                </div>
                <div
                  className="cert-item text-center"
                  style={{
                    background: "#fff",
                    padding: "25px 35px",
                    borderRadius: "10px",
                    boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
                    minWidth: "200px",
                  }}
                >
                  <i
                    className="fa fa-award"
                    style={{ fontSize: "40px", color: "#695041", marginBottom: "15px" }}
                  ></i>
                  <h5 style={{ color: "#333" }}>ISO 9001:2015</h5>
                  <p style={{ fontSize: "12px", color: "#666", margin: 0 }}>
                    Certified Quality Management System
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="team pt-5 pb-5" style={{ background: "#f8f9fa" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="title text-center mb-5">
                <h1>OUR TEAM</h1>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 mb-4">
              <div className="team-member h-100">
                <img
                  src="/img/team/Chainroop Dugar.jpg"
                  alt="Mr. Chainroop S. Dugar"
                  className="img-fluid team-img"
                />
                <div className="team-content text-center">
                  <h4>Mr. Chainroop S. Dugar</h4>
                  <h5>CA (Founder)</h5>
                  <p>
                    Chainroop Dugar – Founder, Shree Mahavir Group With over 30
                    years of experience, Mr. Chainroop Dugar brings strong
                    expertise and vision to the real estate sector. A qualified
                    Chartered Accountant, he combines financial knowledge with
                    sharp business insight. As the Founder of Shree Mahavir Group,
                    he ensures every project is well-planned, financially sound,
                    and efficiently executed. Known for his strategic thinking and
                    hands-on approach, Mr. Dugar has built a reputation for
                    driving steady growth with transparency and trust.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 mb-4">
              <div className="team-member h-100">
                <img
                  src="/img/team/Snehal Patel.jpg"
                  alt="Mr. Snehal M. Patel"
                  className="img-fluid team-img"
                />
                <div className="team-content text-center">
                  <h4>Mr. Snehal M. Patel</h4>
                  <h5>CA (Founder)</h5>
                  <p>
                    A seasoned professional with over 30 years in the real estate
                    industry, Mr. Snehal Patel has been instrumental in shaping
                    the vision of Shree Mahavir Group. A qualified Chartered
                    Accountant, he blends financial expertise with a strong
                    understanding of architecture and construction. Recognized for
                    his exceptional sales acumen, Mr. Patel plays a key role in
                    project planning, design direction, and overall execution. His
                    ability to connect with customers and translate their
                    expectations into thoughtfully planned spaces has contributed
                    significantly to the Group&rsquo;s growth and success.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 mb-4">
              <div className="team-member h-100">
                <img
                  src="/img/team/Dhruvin.jpg"
                  alt="Mr. Dhruvin S. Patel"
                  className="img-fluid team-img"
                />
                <div className="team-content text-center">
                  <h4>Mr. Dhruvin S. Patel</h4>
                  <h5>CTO & CMO</h5>
                  <p>
                    Mr. Dhruvin Patel represents the second generation of
                    leadership at Shree Mahavir Group, driving its next phase of
                    growth with a forward-thinking approach. With a strong
                    foundation in mechanical engineering and management from
                    leading global institutions, he brings a blend of technical
                    expertise and strategic vision to the organization. As the CTO
                    & CMO, he focuses on integrating technology, modern marketing,
                    and efficient project planning into the group&rsquo;s operations.
                    His analytical mindset and hands-on approach continue to
                    strengthen the brand&rsquo;s presence and shape its evolution in
                    Mumbai&rsquo;s luxury real estate landscape.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 mb-4">
              <div className="team-member h-100">
                <img
                  src="/img/team/Rahul Somani.jpg"
                  alt="Mr. Rahul Somani"
                  className="img-fluid team-img"
                />
                <div className="team-content text-center">
                  <h4>Mr. Rahul Somani</h4>
                  <h5>COO</h5>
                  <p>
                    Mr. Rahul Somani, COO, brings a strong blend of financial
                    expertise and operational excellence to the organization. A
                    Chartered Accountant and a Law graduate, he has over 6 years
                    of experience with a leading Big 4 organization, where he
                    specialized in international and domestic taxation as well as
                    transfer pricing. With over 4 years of experience in the real
                    estate sector, Rahul plays a key role in driving operational
                    efficiency, strengthening financial processes, and ensuring
                    seamless project execution. His structured approach and sharp
                    analytical mindset continue to support the company&rsquo;s growth
                    and long-term stability.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default About;